import { EvaluationRating } from '../interfaces/evaluation';
export const EvaluationCountLimit: number = 16;

// Max number of URIs to be returned when querying by evaluation (eg. for isBadSignal)
export const QueryByEvaluationLimit: number = 100;

export const EvaluationRatings: Array<EvaluationRating> = [
  {
    title: 'relevance',
    ratings: [
      {
        key: 'strong',
        value: 'Strong'
      },
      {
        key: 'weak',
        value: 'Weak'
      },
      {
        key: 'none',
        value: 'None'
      }
    ]
  },
  {
    title: 'correlation',
    ratings: [
      {
        key: 'positive',
        value: 'Positive'
      },
      {
        key: 'negative',
        value: 'Negative'
      }
    ]
  }
];
